import { makeStyles } from '@material-ui/core'
import { css } from 'styled-components'
import { content } from '~/themes/colors'

export const addressFieldStyle = css`
	width: 100%;
`

export const useStyles = makeStyles((theme) => ({
	label: {
		color: theme?.palette?.primary?.main,
		marginBottom: 4,
		...theme?.typography?.subtitle2,
	},
	root: {
		width: '100%',

		'& input': {
			...theme?.typography?.body1,
			color: content.veryDark,
			marginBottom: 8,
		},

		'& input::placeholder': {
			color: content.dark,
			opacity: 1,
			textOverflow: 'ellipsis !important',
		},
	},
}))
